import { LoadablePaint } from '@confluence/loadable';

export const SplitPageResultsLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SplitPageResults" */ '../src/components/SplitPageResults/SplitPageResults.tsx'
			)
		).SplitPageResults,
});
